
  var _styles = {
  "bottom-slider-modal": {
    "borderTopLeftRadius": "0.48rem",
    "borderTopRightRadius": "0.48rem",
    "position": "relative",
    "zIndex": 2,
    "backgroundColor": "rgb(244,244,244)"
  },
  "bottom-slider-modal__close-btn": {
    "position": "absolute",
    "top": "0.16rem",
    "right": "-0.02667rem",
    "width": "1.17333rem",
    "height": "1.17333rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "zIndex": 10
  },
  "bottom-slider-modal__close-icon": {
    "width": "0.42667rem",
    "height": "0.42667rem"
  },
  "bottom-slider-modal__header": {
    "width": "10rem",
    "height": "1.44rem",
    "display": "flex",
    "alignItems": "center",
    "flexDirection": "row",
    "justifyContent": "center",
    "borderBottomWidth": "0.01333rem",
    "borderBottomStyle": "solid",
    "borderBottomColor": "rgb(245,245,245)",
    "position": "relative"
  },
  "bottom-slider-modal__title": {
    "fontSize": "0.48rem",
    "fontWeight": "600",
    "color": "rgb(51,51,51)"
  },
  "bottom-slider-modal__content": {
    "width": "10rem",
    "overflow": "hidden"
  }
};



  module.exports = _styles;
  